import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, unref as _unref, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "tile is-ancestor" }
const _hoisted_3 = { class: "tile is-parent is-vertical" }
const _hoisted_4 = { class: "tile is-child" }
const _hoisted_5 = { class: "card has-table has-mobile-sort-spaced" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("header", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "card-header-title" }, " Noticias ")
], -1)
const _hoisted_7 = { class: "card-content" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("progress", {
  class: "progress is-small is-info",
  max: "100"
}, " 15% ", -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = {
  key: 0,
  class: "custom-margin is-flex is-justify-content-space-between is-flex-wrap-wrap"
}
const _hoisted_14 = { "aria-label": "Page navigation" }
const _hoisted_15 = { class: "pagination is-flex is-justify-content-end" }

import { onMounted, ref } from "vue";
import { newsService } from "@/services";
import News from "@/entities/news";
import { Paginated } from "@/pagination";
import Pagination from "laravel-vue-pagination";
import NewCard from "@/components/news/NewsCard.vue"


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const isNewsLoading = ref<boolean>(false);
const news = ref<Paginated<News[]>>();

const getAllNews = async (page = 1) => {
  isNewsLoading.value = !isNewsLoading.value;
  try {
    news.value = await newsService.getPublicNews(page);
    console.log(news.value);
  } catch (e) {
    console.log(e);
  } finally {
    isNewsLoading.value = !isNewsLoading.value;
  }
};

const handleNextPage = async (page: number) => {
  await getAllNews(page);
};

onMounted(async () => {
  await getAllNews();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              (isNewsLoading.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
                : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    (news.value !== undefined)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                          (news.value.data?.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(news.value.data, (currentNew) => {
                                  return (_openBlock(), _createBlock(NewCard, {
                                    "current-new": currentNew,
                                    key: currentNew?.id,
                                    class: "block card-size"
                                  }, null, 8, ["current-new"]))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", null, [
                            _createElementVNode("nav", _hoisted_14, [
                              _createElementVNode("ul", _hoisted_15, [
                                _createVNode(_unref(Pagination), {
                                  data: news.value,
                                  limit: 9,
                                  onPaginationChangePage: handleNextPage
                                }, null, 8, ["data"])
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})